import "./App.css";
import About from "./components/About.component";
import Disclaimer from "./components/Disclaimer.component";
import FormComponent from "./components/Form.component";
import ProjectPartners from "./components/ProjectPartners.component";
import BySubscribing from "./components/BySubscribing.component";
import LayoutHeader from "./global/layout/header";
import { siteContent } from "./content";

const intro = siteContent.intro;

function App() {
  return (
    <div>
      <div className="pb-40 bg-gradient-to-b from-sky-50 to-white min-h-[90vh]">
        <div className="container">
          <LayoutHeader />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-10">
            <div>
              <h1 className="text-4xl md:text-6xl font-semibold text-gray-900 mt-8 md:mt-16 leading-tight">
                {intro.subscribeToOur}{" "}
                <span className="text-blue-400">{intro.newsletter}</span>
              </h1>
              <div className="hidden md:block">
                <Disclaimer />
              </div>
            </div>
            <div className="mt-5">
              <FormComponent />
              <div className="block md:hidden">
                <Disclaimer />
              </div>
            </div>
          </div>
          <BySubscribing />
        </div>
      </div>
      <About />
      <ProjectPartners />
    </div>
  );
}

export default App;
